import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconPicture16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="picture">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 1C0.447715 1 0 1.44772 0 2V14C0 14.5523 0.447715 15 1 15H15C15.5523 15 16 14.5523 16 14V2C16 1.44772 15.5523 1 15 1H1ZM2 10.9603V3H14V10.7639L10.8944 4.55279C10.7289 4.22184 10.3943 4.00931 10.0244 4.0003C9.65446 3.99128 9.30982 4.18725 9.12842 4.50974L6.88008 8.50678L5.79999 7.06667C5.59724 6.79633 5.27168 6.64668 4.93448 6.66882C4.59729 6.69095 4.29409 6.88189 4.12842 7.17641L2 10.9603ZM3.14734 13H12.882L9.94802 7.13212L7.87157 10.8236C7.7059 11.1181 7.4027 11.309 7.0655 11.3312C6.72831 11.3533 6.40274 11.2037 6.19999 10.9333L5.11991 9.49322L3.14734 13Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconPicture24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="picture">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 4C0 2.89543 0.895431 2 2 2H22C23.1046 2 24 2.89543 24 4V20C24 21.1046 23.1046 22 22 22H2C0.895432 22 0 21.1046 0 20V4ZM22 4H2V18.3814L6.71368 12.3822C6.90015 12.1449 7.18383 12.0044 7.48562 12.0001C7.7874 11.9958 8.07501 12.128 8.26822 12.3598L9.93907 14.3648L14.1863 8.41876C14.3795 8.14827 14.6945 7.99146 15.0268 8.00036C15.3591 8.00925 15.6652 8.18268 15.8437 8.46313L22 18.1374V4ZM20.8147 20H3.27175L7.52287 14.5895L9.23178 16.6402C9.43013 16.8782 9.72762 17.0108 10.0372 16.9993C10.3469 16.9878 10.6336 16.8334 10.8137 16.5812L14.9522 10.7874L20.8147 20ZM7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8C9 8.55228 8.55228 9 8 9C7.44772 9 7 8.55228 7 8ZM8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconPicture48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="picture">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 9C0 7.34315 1.34315 6 3 6H45C46.6569 6 48 7.34315 48 9V39C48 40.6569 46.6569 42 45 42H3C1.34315 42 0 40.6569 0 39V9ZM3 8C2.44772 8 2 8.44772 2 9V38.3992L13.2191 24.3753C13.4052 24.1427 13.6852 24.0052 13.983 24.0001C14.2808 23.9951 14.5654 24.1231 14.7592 24.3492L19.9128 30.3617L30.1759 15.4335C30.3669 15.1557 30.6849 14.9929 31.0218 15.0002C31.3588 15.0076 31.6694 15.1842 31.848 15.47L46 38.1132V9C46 8.44771 45.5523 8 45 8H3ZM44.8207 40L30.9602 17.8231L20.824 32.5665C20.6481 32.8224 20.3632 32.9821 20.0531 32.9986C19.743 33.0151 19.4428 32.8866 19.2407 32.6508L14.0265 26.5676L3.28061 40H44.8207ZM14 13C12.3431 13 11 14.3431 11 16C11 17.6569 12.3431 19 14 19C15.6569 19 17 17.6569 17 16C17 14.3431 15.6569 13 14 13ZM9 16C9 13.2386 11.2386 11 14 11C16.7614 11 19 13.2386 19 16C19 18.7614 16.7614 21 14 21C11.2386 21 9 18.7614 9 16Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
